// @ts-nocheck

import React, { useEffect, useState, useRef } from 'react';
import * as St from './styles';
import { useChat } from '~/contexts/chat';
import Lottie from 'lottie-react';
import TeoAnim from '~/assets/icons/animation.json';

const TeoBubble: React.FC = () => {
  const [hover, setHover] = useState(false);
  const [position, setPosition] = useState(null);
  const { openChat } = useChat();

  const lottieRef = useRef<any>(null);
  const directionRef = useRef(1);
  const containerRef = useRef(null);
  const dragRef = useRef(null);
  const draggedRef = useRef(false);

  const keepPositionInsideScreen = (currentPosition, width = 100, height = 100) => {
    if (!currentPosition) return currentPosition;

    const maxX = Math.max(window.innerWidth - width, 0);
    const maxY = Math.max(window.innerHeight - height, 0);

    return {
      x: Math.min(Math.max(currentPosition.x, 0), maxX),
      y: Math.min(Math.max(currentPosition.y, 0), maxY),
    };
  };

  const handleComplete = () => {
    const anim = lottieRef.current;
    if (!anim) return;

    directionRef.current = directionRef.current * -1;

    anim.setDirection(directionRef.current);
    anim.play();
  };

  const handlePointerDown = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();

    draggedRef.current = false;
    dragRef.current = {
      startX: event.clientX,
      startY: event.clientY,
      initialX: rect.left,
      initialY: rect.top,
      width: rect.width,
      height: rect.height,
    };

    const handlePointerMove = (moveEvent) => {
      if (!dragRef.current) return;

      const diffX = moveEvent.clientX - dragRef.current.startX;
      const diffY = moveEvent.clientY - dragRef.current.startY;

      if (Math.abs(diffX) > 4 || Math.abs(diffY) > 4) {
        draggedRef.current = true;
      }

      const maxX = Math.max(window.innerWidth - dragRef.current.width, 0);
      const maxY = Math.max(window.innerHeight - dragRef.current.height, 0);

      setPosition({
        x: Math.min(Math.max(dragRef.current.initialX + diffX, 0), maxX),
        y: Math.min(Math.max(dragRef.current.initialY + diffY, 0), maxY),
      });
    };

    const handlePointerUp = () => {
      dragRef.current = null;
      document.removeEventListener('pointermove', handlePointerMove);
      document.removeEventListener('pointerup', handlePointerUp);
    };

    document.addEventListener('pointermove', handlePointerMove);
    document.addEventListener('pointerup', handlePointerUp);
  };

  const handleClick = () => {
    if (draggedRef.current) {
      draggedRef.current = false;
      return;
    }

    openChat();
  };

  useEffect(() => {
    const handleResize = () => {
      const rect = containerRef.current?.getBoundingClientRect();

      setPosition((currentPosition) =>
        keepPositionInsideScreen(currentPosition, rect?.width, rect?.height)
      );
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <St.Container
      ref={containerRef}
      style={
        position
          ? {
              left: position.x,
              top: position.y,
              right: 'auto',
              bottom: 'auto',
            }
          : undefined
      }
    >
      <St.Bubble
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onPointerDown={handlePointerDown}
        onClick={handleClick}
      >
        {hover && (
          <St.MessageBox>
            <strong>Oi!</strong>
            <span>Eu sou o Teo, seu assistente virtual.</span>
            <span>Como posso te ajudar hoje?</span>
          </St.MessageBox>
        )}

        <St.TeoCircle>
          <Lottie
            lottieRef={lottieRef}
            animationData={TeoAnim}
            autoplay={true}
            loop={false}
            onComplete={handleComplete}
          />
        </St.TeoCircle>
      </St.Bubble>
    </St.Container>
  );
};

export default TeoBubble;
